import { render, staticRenderFns } from "./TextScheduleForm.vue?vue&type=template&id=5ff2c846&scoped=true"
import script from "./TextScheduleForm.vue?vue&type=script&lang=js"
export * from "./TextScheduleForm.vue?vue&type=script&lang=js"
import style0 from "./TextScheduleForm.vue?vue&type=style&index=0&id=5ff2c846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff2c846",
  null
  
)

export default component.exports